export default {
    name: "RichText",
    setup(){
        
    }
}